import styled from "@emotion/styled";
import { RequiredThemeKeys } from "../../../util/theme";
import { tooltipTheme } from "../tooltipTheme";

interface TooltipBodyStyledProps {
    themeMode: RequiredThemeKeys;
}

export const TooltipBodyStyled = styled("div")<TooltipBodyStyledProps>`
    padding: ${({ themeMode }) => tooltipTheme.padding.body(themeMode)};

    // These are set to ensure the arrow calculations don't create an infinite loop due. See #468.
    min-height: 8px;
    min-width: 8px;

    > * {
        color: ${({ themeMode }) => tooltipTheme.textColor.title(themeMode)};
    }
`;
